<template>
  <div class="main-body">
    <div class="header">销售总额</div>
    <div class="out">

      <div class="search2">

        <div style="float:right">

          <el-select v-model="businessCode" placeholder="请选择商家" style="margin-right:5px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.name"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-date-picker size="mini"
                          ref="picker"
                          v-model="datetimerangeValue"
                          type="daterange"
                          :clearable='false'
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width:230px;margin-right:5px">
          </el-date-picker>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>
      <el-table class="table" size="mini" v-loading="tableLoading"
                :data="tableData" :height="th" border>

        <el-table-column prop="payType" :formatter="statusTitle" label="支付类型"></el-table-column>
        <el-table-column prop="orderNumber" label="订单数"></el-table-column>
        <el-table-column prop="totalcollection" label="总金额"></el-table-column>

      </el-table>

    </div>

  </div>
</template>


<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import { getStaffCode, getStaffDTO} from "@/utils/auth";


export default {
  name: "Role",
  data(){
    return{

      tableLoading:false,

      tableData:[],


      th:0,

      governmentCode:getStaffDTO().governmentCode,


      datetimerangeValue:'',

      arr_business:[],
      businessCode:'',


    }
  },
  components:{

  },
  created(){

    const end= new Date();
    const start=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30);
    this.datetimerangeValue=[start, end];

    this.getBusiness();

    this.th = this.$store.state.tableHeight+50;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{

    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getList();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },

    timefilter(row,index,column){
      return timefilters(column).slice(0,10)
    },

    getList() {

      this.tableLoading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        businessCode:this.businessCode,
        startTime:timefilters(this.datetimerangeValue[0]).slice(0,10),
        endTime:timefilters(this.datetimerangeValue[1]).slice(0,10),
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"OrderBusiness/OrderStatistics2",
        data: data
      }).then( (response)=> {
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        //_this.tableLoading=false
        console.log(error);
      });
    },

    statusTitle(row) {
      if (row.payType === 'yue') {
        return "余额";
      }
      if (row.payType === 'ali') {
        return "支付宝";
      }
      if (row.payType === 'wx') {
        return "微信";
      }
      if (row.payType === 'cash') {
        return "现金";
      }
      return '其它';
    },


  }
}
</script>

<style lang="scss" scoped>

</style>
